import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Typography,
  Paper,
  Grid,
  CircularProgress,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { baseurl } from "domain";
import { useNavigate } from "react-router-dom";
import { convertTo12Hour } from "utils/converterUtils";

function BookingDetails() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const payment_id = queryParams.get("payment_id");

  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");

  useEffect(() => {
    if (payment_id) {
      fetchBookingDetails();
    }
  }, [payment_id]);

  const fetchBookingDetails = async () => {
    try {
      const response = await axios.get(
        `https://${baseurl}/getCanceledBookingDetails?payment_id=${payment_id}`
      );
      setBooking(response.data.booking);
    } catch (error) {
      console.error("Error fetching booking details:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatType = (type) => {
    return type === "press-conf" ? "Press Conference" : "Program";
  };

  const formatDuration = (duration) => {
    return duration === "30" ? "30 minutes" : `${duration / 60} hours`;
  };

  const handleCancelClick = () => {
    setOpenCancelDialog(true);
  };

  const handleCancelBooking = () => {
    setOpenCancelDialog(false);
    setOpenConfirmDialog(true);
  };

  const handleConfirmCancel = async () => {
    try {
      await axios.post(`https://${baseurl}/cancelPCHBooking`, {
        payment_id,
        reason,
        remark,
      });

      alert("Booking successfully canceled.");
      setOpenConfirmDialog(false);
      fetchBookingDetails(); // Refresh details
    } catch (error) {
      console.error("Error canceling booking:", error);
      alert("Failed to cancel booking.");
    }
  };

  const navigate = useNavigate();
  const handleRescheduleBooking = () => {
    navigate(`/editPCHBooking?payment_id=${payment_id}`);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
          <Typography variant="h4" gutterBottom>
            Booking Details
          </Typography>

          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress />
            </Box>
          ) : booking ? (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Date:</Typography>
                <Typography>{booking.date}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Event Type:</Typography>
                <Typography>{formatType(booking.type)}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Subject:</Typography>
                <Typography>{booking.subject}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Gov ID:</Typography>
                <Typography>{booking.govId}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Duration:</Typography>
                <Typography>{formatDuration(booking.duration)}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Time Slot:</Typography>
                <Typography>
                  {convertTo12Hour(booking.start_time)} - {convertTo12Hour(booking.end_time)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Name:</Typography>
                <Typography>{booking.name}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Organization Name:</Typography>
                <Typography>{booking.insName}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Email:</Typography>
                <Typography>{booking.email}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Phone Number:</Typography>
                <Typography>{booking.phnNo}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Amount Paid:</Typography>
                <Typography>₹ {booking.amount / 100}</Typography>
              </Grid>
              {booking.gstNo && (
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6">GST NO.:</Typography>
                  <Typography>{booking.gstNo}</Typography>
                </Grid>)}
              {/* <Grid item xs={12} sm={6}>
                <Typography variant="h6">Booking Status:</Typography>
                <Typography>{booking.status}</Typography>
              </Grid> */}

              {booking.remark && (
                <>
                  <Grid item xs={12} sm={6}>
                    <Typography><strong>Remark:</strong> {booking.remark}</Typography>
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <Typography variant="h6">Booked By:</Typography>
                <Typography>{booking.bookedBy}</Typography>
              </Grid>

              {/* Show Payment ID & Order ID if booked online */}
              {booking.bookedBy === "Online" && (
                <>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="h6">Payment ID:</Typography>
                    <Typography>{booking.payment_id}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="h6">Order ID:</Typography>
                    <Typography>{booking.order_id || "N/A"}</Typography>
                  </Grid>
                </>
              )}

              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Cancel Reason:</Typography>
                <Typography>{booking.cancelReason || "N/A"}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Cancel Remark:</Typography>
                <Typography>{booking.cancelRemark || "N/A"}</Typography>
              </Grid>

              {/* Action Buttons */}
              {/* <Grid item xs={12} sx={{ mt: 3 }}>
                <Box display="flex" justifyContent="space-between">
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#d32f2f",
                      color: "white !important",
                      "&:hover": { backgroundColor: "#b71c1c" },
                    }}
                    onClick={handleCancelClick}
                  >
                    Cancel
                  </Button>
                  <Button variant="contained" color="primary" onClick={handleRescheduleBooking}>
                    Re-Schedule
                  </Button>
                </Box>
              </Grid> */}
            </Grid>
          ) : (
            <Typography color="error">No booking details found.</Typography>
          )}
        </Paper>
      </Container>

      {/* Cancel Reason Dialog */}
      <Dialog open={openCancelDialog} onClose={() => setOpenCancelDialog(false)}>
        <DialogTitle>Cancel Booking</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Reason"
            variant="outlined"
            margin="dense"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          <TextField
            fullWidth
            label="Remark"
            variant="outlined"
            margin="dense"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCancelDialog(false)} color="secondary">
            Back
          </Button>
          <Button variant="contained" sx={{ backgroundColor: "red", color: "white !important" }} onClick={handleCancelBooking}>
            Cancel Booking
          </Button>
        </DialogActions>
      </Dialog>

      {/* Final Confirmation Dialog */}
      <Dialog open={openConfirmDialog} onClose={() => setOpenConfirmDialog(false)}>
        <DialogTitle>Confirm Cancellation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to cancel this booking?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDialog(false)} color="secondary">
            No
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#d32f2f", color: "white !important" }}
            onClick={handleConfirmCancel}
          >
            Yes, Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Footer />
    </DashboardLayout>
  );
}

export default BookingDetails;
